<template>
  <b-container fluid class="bv-example-row bv-example-row-flex-cols">
    <b-row align-v="center">
      <b-col cols="auto">
        <b-form-select
          v-model="reportTypeComputed"
          :options="reportTypeOptions"
        >
          <template slot="first">
            <option :value="null" disabled>-- เลือกรูปแบบรายงาน --</option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="auto">
        <b-form-radio-group
          id="date-type-radio"
          v-model="dateTypeHandler"
          :options="dateTypeOptions"
          name="date-type-radio"
        />
      </b-col>
      <b-col cols="auto">
        <b-form-group label="จาก" label-cols="2" class="m-auto">
          <!--          :disabled-dates="fromDateDisableHandler"-->
          <datepicker
            v-model="fromDateHandler"
            :format="dateFormat"
            :input-class="{ 'form-control': true, 'white-background': true }"
            :minimum-view="dateType"
          />
        </b-form-group>
      </b-col>
      <b-col cols="auto">
        <b-form-group label="ถึง" label-cols="2" class="m-auto">
          <datepicker
            v-model="toDateHandler"
            :disabled-dates="toDateDisableHandler"
            :format="dateFormat"
            :input-class="{ 'form-control': true, 'white-background': true }"
            :minimum-view="dateType"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment-timezone";

export default {
  name: "FilterComponent",
  components: {
    Datepicker,
  },
  props: {
    reportType: {
      required: true,
    },
    dateType: {
      required: true,
    },
    fromDate: {
      required: true,
    },
    toDate: {
      required: true,
    },
  },
  data() {
    return {
      reportTypeOptions: [
        { value: "invoiceReport", text: "รายงานใบแจ้งหนี้แบบรวม" },
        { value: "testReport", text: "รายงานการตรวจแบบแจกแจง" },
        { value: "animalReport", text: "รายงานการตรวจแบบภาพรวม" },
        { value: "specimenReport", text: "รายงานแจกแจง specimen type" },
      ],
      dateTypeOptions: [
        { text: "รายวัน", value: "date" },
        { text: "รายเดือน", value: "month" },
        { text: "รายปี", value: "year" },
      ],
      dateFormat: "MMM yyyy",
    };
  },
  computed: {
    reportTypeComputed: {
      get() {
        return this.reportType;
      },
      set(value) {
        this.$emit("update:reportType", value);
      },
    },
    dateTypeHandler: {
      get() {
        return this.dateType;
      },
      set(value) {
        this.$emit("update:dateType", value);
      },
    },
    fromDateHandler: {
      get() {
        return this.fromDate;
      },
      set(value) {
        this.$emit("update:fromDate", value);
      },
    },
    toDateHandler: {
      get() {
        return this.toDate;
      },
      set(value) {
        this.$emit("update:toDate", value);
      },
    },
    toDateDisableHandler() {
      let handler = {
        to: this.fromDateHandler,
      };

      if (this.dateTypeHandler === "date") {
        handler = {
          ...handler,
          from: this.fromDateHandler
            ? new Date(moment(this.fromDateHandler).add(1, "M"))
            : "",
        };
      } else if (this.dateTypeHandler === "month") {
        // this.fromDateHandler = new Date(
        //         this.fromDateHandler.getFullYear(),
        //         this.fromDateHandler.getMonth() + 12,
        //         1
        //       )
        // this.toDateHandler = new Date(
        //         this.toDateHandler.getFullYear(),
        //         this.toDateHandler.getMonth(),
        //         0
        //       )
        handler = {
          ...handler,
          from: this.fromDateHandler
            ? new Date(
                this.fromDateHandler.getFullYear(),
                this.fromDateHandler.getMonth() + 12,
                this.fromDateHandler.getDay()
              )
            : "",
        };
      } else if (this.dateTypeHandler === "year") {
        // this.fromDateHandler = new Date(
        //         this.fromDateHandler.getFullYear(),
        //         this.fromDateHandler.getMonth() + 12,
        //         1
        //       )
        // this.toDateHandler = new Date(
        //         this.toDateHandler.getFullYear(),
        //         this.toDateHandler.getMonth(),
        //         0
        //       )
        handler = {
          ...handler,
          from: this.fromDateHandler
            ? new Date(
                this.fromDateHandler.getFullYear() + 12,
                this.fromDateHandler.getMonth(),
                this.fromDateHandler.getDay()
              )
            : "",
        };
      }
      return handler;
    },
    fromDateDisableHandler() {
      return {
        from: this.toDateHandler,
      };
    },
  },
  watch: {
    fromDateHandler(val) {
      // this.toDateHandler = this.fromDateHandler
    },
    dateTypeHandler(newValue) {
      this.$nextTick(() => {
        switch (newValue) {
          case "date":
            this.fromDateHandler = moment()
              .startOf("month")
              .toDate();
            this.toDateHandler = moment()
              .endOf("month")
              .toDate();
            this.dateFormat = "dd MMM yyyy";
            break;
          case "month":
            this.fromDateHandler = moment()
              .startOf("month")
              .toDate();
            this.toDateHandler = moment()
              .endOf("month")
              .toDate();
            this.dateFormat = "MMM yyyy";
            break;
          case "year":
            this.fromDateHandler = moment()
              .startOf("year")
              .toDate();
            this.toDateHandler = moment()
              .endOf("year")
              .toDate();
            this.dateFormat = "yyyy";
            break;
        }
      });
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
